export class organizeProtocol {
  public static readonly ORGANIZE_MANAGEMENT_DATA: string = `api/organizeManagement`;
  public static readonly ORGANIZE_MANAGEMENT_GET_ID: string = 'api/organizeManagement/getId';
  public static readonly ORGANIZE_MANAGEMENT_CREATE_DATA: string = `api/organizeManagement/create`;
  public static readonly ORGANIZE_MANAGEMENT_UPDATE_DATA: string = `api/organizeManagement/update`;
  public static readonly ORGANIZE_MANAGEMENT_DELETE_DATA: string = `api/organizeManagement/delete`;
}
